module.exports = __webpack_public_path__ + "img/toilet-paper.14d40fc9.svg";